import { render, staticRenderFns } from "./PagePurchaseGallery.vue?vue&type=template&id=f82eb068&scoped=true&"
import script from "./PagePurchaseGallery.vue?vue&type=script&lang=ts&"
export * from "./PagePurchaseGallery.vue?vue&type=script&lang=ts&"
import style0 from "./PagePurchaseGallery.vue?vue&type=style&index=0&id=f82eb068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82eb068",
  null
  
)

export default component.exports